<template>
  <transition name="o-transition__modal">
    <CallCenterAEDModal
      v-if="showModal"
      @close="closeModal"
      class="c-aed-statusChange"
    >
      <template v-if="!confirmation">
        <h2
          class="o-heading o-heading--size-2 o-heading--section o-heading--border"
          slot="header"
        >
          {{ translationsStatusModal.modalHeadline }}
        </h2>
        <div slot="body">
          <div class="o-grid o-grid--gutter-small">
            <div class="o-grid__group">
              <div class="o-grid__item o-grid__item--12">
                <div v-html="aedAddress" class="o-field"></div>
                <span
                  class="o-status--text"
                  :class="status.statusDetailsValue | statusToColor"
                  >{{ translationsStatus.code[status.statusDetails] }}</span
                >
              </div>
              <div class="o-grid__item o-grid__item--12">
                <div class="o-grid o-grid--gutter-tiny">
                  <div class="o-grid__group">
                    <div
                      class="o-grid__item o-grid__item--12"
                      v-for="status in availableStatusChange"
                      :key="status"
                    >
                      <input
                        type="radio"
                        class="o-radio"
                        v-model="mutableObject.statusChange"
                        v-bind:value="status"
                        :id="`radio-${status}`"
                      />
                      <label :for="`radio-${status}`">{{
                        translationsStatusModal.code[status] || status
                      }}</label>
                    </div>
                  </div>
                </div>
              </div>
              <div class="o-grid__item o-grid__item--12">
                <h4
                  class="c-aed-statusChange__text-label o-heading o-heading--size-4 o-label o-label--block"
                >
                  {{ translationsHistory.comment || "" }}
                </h4>
                <textarea
                  class="c-aed-statusChange__text-area o-input o-input--modal"
                  name="comment"
                  :placeholder="translationsHistory.addCommentPlaceholder || ''"
                  v-model="mutableObject.comment"
                  id=""
                  cols="30"
                  rows="10"
                ></textarea>
              </div>
              <div class="o-grid__item o-grid__item--12">
                <h4
                  class="c-aed-statusChange__text-label o-heading o-heading--size-4 o-label o-label--block"
                >
                  {{ translationsStatusModal.dateToContactOwner || "" }}
                </h4>
                <v-datepicker
                  input-class="c-aed-editableDate__input"
                  wrapper-class="c-aed-editableDate__wrap"
                  calendar-class="c-aed-editableDate__calendar"
                  :value="mutableObject.date"
                  :use-utc="false"
                  format="dd-MM-yyyy"
                  :mondayFirst="true"
                  :language="datepickerLanguage"
                  :disabledDates="{
                    to: minimumSelectableDay
                  }"
                  :calendar-button="true"
                  calendar-button-icon="o-svg-icon o-svg-icon--calendar"
                  @input="mutableObject.date = $event"
                ></v-datepicker>
              </div>
            </div>
          </div>
        </div>
        <div slot="footer">
          <div class="o-grid o-grid--gutter-small">
            <div class="o-grid__group">
              <div
                class="c-aed-statusChange__footer-item o-grid__item o-grid__item--grow-0"
              >
                <button
                  class="o-button"
                  @click="
                    statusChangeRequiresConfirmation
                      ? toggleConfirmation()
                      : submitStatus()
                  "
                  :disabled="mutableObject.statusChange === null"
                >
                  {{ translationsStatusModal.saveNewStatus }}
                </button>
              </div>
              <div
                class="c-aed-statusChange__footer-item o-grid__item o-grid__item--grow-0"
              >
                <button
                  class="o-button o-button--transparent"
                  @click="closeModal()"
                >
                  {{ translationsCustom.cancel || "" }}
                </button>
              </div>
            </div>
          </div>
        </div>
      </template>
      <template v-else>
        <h2
          class="o-heading o-heading--size-2 o-heading--section o-heading--border"
          slot="header"
        >
          {{ translationsStatusModal.deleteConfirmationHeadline }}
        </h2>
        <div slot="footer">
          <div class="o-grid o-grid--gutter-small">
            <div class="o-grid__group">
              <div
                class="c-modal-comment__footer-item o-grid__item o-grid__item--grow-0"
              >
                <button class="o-button" @click="submitStatus">
                  {{ translationsStatusModal.deleteConfirmationSubmit }}
                </button>
              </div>
              <div
                class="c-modal-comment__footer-item o-grid__item o-grid__item--grow-0"
              >
                <button
                  class="o-button o-button--transparent"
                  @click="toggleConfirmation"
                >
                  {{ translationsCustom.cancel || "" }}
                </button>
              </div>
            </div>
          </div>
        </div>
      </template>
    </CallCenterAEDModal>
  </transition>
</template>

<script>
import { mapGetters, mapState } from "vuex";
import { da } from "vuejs-datepicker/dist/locale";
export default {
  data() {
    return {
      section: "status",
      name: "Angiv status",
      pageNo: 1,
      showModal: false,
      datepickerLanguage: da,
      confirmation: false,
      mutableObject: {
        comment: null,
        statusChange: null,
        date: null
      }
    };
  },
  props: {
    showStatusChange: { type: Boolean, required: true }
  },
  computed: {
    ...mapGetters("aed", [
      "parameters",
      "address",
      "status",
      "availableStatusChange",
      "minimumSelectableDay"
    ]),
    ...mapState("translations", {
      translationsStatus: "status",
      translationsStatusModal: "statusModal",
      translationsHistory: "history",
      translationsCustom: "custom"
    }),
    aedAddress() {
      // eslint-disable-next-line prettier/prettier
      return `<b>${this.address.organisation}</b>, ${this.address.street} ${this.address.number} ${this.address.floor}, ${this.address.city}`;
    },
    statusChangeRequiresConfirmation() {
      return this.mutableObject.statusChange === "Delete";
    }
  },
  methods: {
    closeModal() {
      this.showModal = false;
      this.$emit("close");
    },
    submitStatus() {
      const payload = {
        api: this.$api,
        method: "POST",
        id: this.$store.state.aed.all.id,
        section: this.section,
        data: this.mutableObject
      };
      const { dispatch } = this.$store;
      dispatch("aed/setSection", payload);
      this.closeModal();
    },
    toggleConfirmation() {
      this.confirmation = !this.confirmation;
    },
    getAvailableStatusChange() {
      const payload = {
        api: this.$api,
        status: this.status.statusDetails
      };
      const { dispatch } = this.$store;
      dispatch("aed/getAvailableStatusChange", payload);
    }
  },
  created() {
    this.getAvailableStatusChange();

    this.$nextTick(() => {
      this.showModal = this.showStatusChange;
    });
  }
};
</script>

<style lang="scss">
@import "~svg-spritemap-webpack-plugin/sprites.scss";
.c-aed-statusChange {
  .vdp-datepicker {
    width: 298px;
    &__calendar-button {
      position: absolute;
      top: 50%;
      transform: translateY(-50%);
      right: 15px;
      pointer-events: none;
      + input {
        padding-right: 40px;
      }
    }
    .o-svg-icon {
      &--calendar {
        @include sprite("date");
        width: 22px;
        height: 22px;
        display: block;
      }
    }

    input {
      border: 1px solid $s-cp-neutral-600;
      border-radius: 3px;
      height: auto;
      padding: 10px;
      &:disabled {
        border: 1px solid transparent;
        background: transparent;
      }
    }
  }

  &__text-area {
    height: 80px;
    resize: none;
    width: 100%;
  }
}
</style>
